/**
 * 创建赛事表单默认值（非接口模拟数据）
 */

export function createDefaultForm() {
  return {
    competitionId: null,
    matchType: 1,
    title: "",
    signTime: [],
    endTime: [],
    finishType: undefined,
    runTypes: [1],
    groups: [{ type: 1, distanceType: 0, distance: "", customName: "" }],
    paceType: 0,
    paceMin: undefined,
    paceMax: undefined,
    paceMinEnd: undefined,
    paceMaxEnd: undefined,
    coverUrl: "",
    coverFile: null,
    visualUrl: "",
    visualFile: null,
    mainColorBgUrl: "",
    mainColorBgFile: null,
    introUrl: "",
    introFile: null,
    headerImgUrl: "",
    headerImgFile: null,
    introImgUrl: "",
    introImgFile: null,
    guideImgUrl: "",
    guideImgFile: null,
    detailImgUrl: "",
    detailImgFile: null,
    ruleImgUrl: "",
    ruleImgFile: null,
    shareCoverUrl: "",
    shareCoverFile: null,
    shareTitle: "",
    shareDesc: "",
    combo: [],
    publishType: 1,
    // 新增赛事默认带一个空套餐，避免进来时套餐区完全空白（edit/view/copy 会被 applyDetailToForm 覆盖）
    packages: [
      {
        id: 1,
        packageTitle: "",
        coverUrl: "",
        coverFile: null,
        priceType: 1,
        price: "",
        limitType: 1,
        stockType: 0,
        stock: "",
        deliveryDeadline: "",
        prizeList: [],
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/components/yunying/onlineMatch/mockData.js